import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getMyProfileSuspended } from "../../api";
import useMe from "../../hooks/useMe";
import { useAuthStore } from "../../store";
import { ISuspend } from "../../types";
import Suspended from "./Suspended";

function Chat() {

    /* state */

    const { isLoggedIn, isGuest } = useAuthStore();

    /* me */

    const { meData, meLoading } = useMe();
    const isMember = meData?.user.type === "MEMBER";

    /* query */

    const { data: suspendList } = useQuery<ISuspend[]>({
        queryKey: ["getMyProfileSuspended"],
        queryFn: getMyProfileSuspended,
        enabled: isLoggedIn && !isGuest && !isMember,
    });

    const isSuspended = useMemo(() => {
        if (suspendList === undefined) return false;
        return suspendList.some((suspend) => !suspend.isLifted);
    }, [suspendList]);

  //////////////////////////////////////////////////////////////

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (isGuest) {
    return <Navigate to="/" replace />;
  }

  if (meLoading) {
    return null;
  }

  if (isMember) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
        {isSuspended ? (
            <Suspended suspendList={suspendList ?? []} />
        ) : (
            <Outlet />
        )}
    </>
  );
}

export default Chat;
